import {IPrepExtensionsServerSettings} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../../../../httpClient/serverApi/requests/Request';

export interface IGetPrepExtensionsServerSettingsParams {}

export type IGetPrepExtensionsServerSettingsResult = IResult & IPrepExtensionsServerSettings;

export class GetPrepExtensionsServerSettingsRequest extends Request<IGetPrepExtensionsServerSettingsParams, IGetPrepExtensionsServerSettingsResult> {
  constructor(params: IGetPrepExtensionsServerSettingsParams) {
    super('getPrepExtensionsServerSettings', params);
  }
}
